//const URL = process.env.NODE_ENV === 'production' ? 'http://rm.cyberinco.cn/' : 'http://localhost:5000/'
const URL = process.env.NODE_ENV === 'production' ? 'https://rm.dafac.online/' : 'http://localhost:5000/'
export default URL
